// Hilfsfunktion, um den Slider auf den nächsten gültigen Monat zu setzen
export function findNearestMonth (value, months) {
  return months.reduce((prev, curr) => Math.abs(curr - value) < Math.abs(prev - value) ? curr : prev)
}

// show form and scroll to it
export function showAndScrollToForm (intLeasingCalc, labels) {
  const requestMessage1 = intLeasingCalc.querySelector('#requestMessage1')
  if (requestMessage1) {
    requestMessage1.value = labels.formContent.startsWith('???')
      ? ''
      : labels.formContent || ''
    requestMessage1.parentElement.classList.add('active')
  }
  const formContainer = intLeasingCalc.querySelector('.leasing-form-container')
  formContainer.style.maxHeight = formContainer.scrollHeight + 'px'

  const formContainerPosition = formContainer.getBoundingClientRect()

  setTimeout(() => {
    window.scrollTo({ top: window.scrollY + formContainerPosition.top - 130, behavior: 'smooth' })
  }, 300)
}

/**
 * Initializes a dropdown with an external placeholder container.
 * @param {HTMLSelectElement} selectEl - The <select> dropdown element.
 * @param {string} placeholderText - Text to be displayed in the external <span>.
 */
export function initPlaceholderDropdown (selectEl, placeholderText) {
  const dropdownContainer = selectEl.closest('.leasing-dropdown')
  const placeholderSpan = dropdownContainer?.querySelector('.placeholder span')
  const placeholderDiv = dropdownContainer?.querySelector('.placeholder')

  if (!selectEl || !placeholderSpan || !placeholderDiv) return

  // Set placeholder text
  placeholderSpan.textContent = placeholderText

  // Add ghost option
  const ghostOption = document.createElement('option')
  ghostOption.value = ''
  ghostOption.disabled = true
  ghostOption.hidden = true
  ghostOption.selected = true
  selectEl.appendChild(ghostOption)

  // Update state based on selection
  const updateState = () => {
    if (selectEl.value) {
      placeholderDiv.classList.add('has-value')
    } else {
      placeholderDiv.classList.remove('has-value')
    }
  }

  // Attach event + set initial state
  selectEl.addEventListener('change', updateState)
  updateState()
}
